import { render, staticRenderFns } from "./scMenu.vue?vue&type=template&id=65741274&scoped=true"
import script from "./scMenu.vue?vue&type=script&lang=js"
export * from "./scMenu.vue?vue&type=script&lang=js"
import style0 from "./scMenu.vue?vue&type=style&index=0&id=65741274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65741274",
  null
  
)

export default component.exports